import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn, fetchAndReturnPDF } from "../utils/utility";

const reserveTicketRequest = (token, companyId, ticketObject) => {
  const url = `${apiURl}/companies/${companyId}/reserve`;
  const parameters = {
    method: "POST",
    body: JSON.stringify(ticketObject),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const reserveTwoWayTicketRequest = (token, companyId, ticketObject) => {
  const url = `${apiURl}/companies/${companyId}/reserve/twoway`;
  const parameters = {
    method: "POST",
    body: JSON.stringify(ticketObject),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const cancelTicketReservationRequest = (token, companyId, ticketId) => {
  const url = `${apiURl}/companies/${companyId}/reserve/${ticketId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const reservedTicketToMyPosRequest = (
  token,
  companyId,
  reservedTicket,
  language
) => {
  const url = `${apiURl}/companies/${companyId}/payment/${language}`;
  const parameters = {
    method: "POST",
    body: JSON.stringify(reservedTicket),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getRefundTicketInformationRequest = (token, companyId, ticketNumber) => {
  const url = `${apiURl}/companies/${companyId}/ticket/${ticketNumber}/cancellation`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const sendSuccessTicketPaymentRequest = (token, myPosCompany, myPosOrderId) => {
  const url = `${apiURl}/companies/${myPosCompany}/payment/${myPosOrderId}/success`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const sendCancelTicketPaymentRequest = (token, myPosCompany, myPosOrderId) => {
  const url = `${apiURl}/companies/${myPosCompany}/payment/${myPosOrderId}/cancel`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getTicketsRequest = (token, companyId, successMyPosTickets) => {
  const url = `${apiURl}/companies/${companyId}/ticket/info`;

  const parameters = {
    method: "PUT",
    body: JSON.stringify(successMyPosTickets),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getTicketPDFRequest = (token, companyId, ticketNumber) => {
  const url = `${apiURl}/companies/${companyId}/ticket/${ticketNumber}/pdf`;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturnPDF(url, parameters);
};

const getReservationInfoByPeriodRequest = (token, companyId, from, to) => {
  const url = `${apiURl}/companies/${companyId}/reserve/logs/${from}/${to}`;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const sendEmailTicketsRequest = (token, companyId, ticketNumber, email) => {
  let url = `${apiURl}/companies/${companyId}/generatePdf/${ticketNumber}`;

  if (email) {
    url += `?email=${email}`;
  }

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturnPDF(url, parameters);
};

const getSingleTicketInfoRequest = (token, companyId, ticketNumber) => {
  let url = `${apiURl}/companies/${companyId}/ticket/info`;

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify([ticketNumber]),
  };

  return fetchAndReturn(url, parameters);
};

const editTicketRequest = (token, companyId, newTicket) => {
  let url = `${apiURl}/companies/${companyId}/ticket`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(newTicket),
  };

  return fetchAndReturn(url, parameters);
};

export {
  reserveTicketRequest,
  reservedTicketToMyPosRequest,
  cancelTicketReservationRequest,
  getRefundTicketInformationRequest,
  sendSuccessTicketPaymentRequest,
  sendCancelTicketPaymentRequest,
  getTicketsRequest,
  getTicketPDFRequest,
  reserveTwoWayTicketRequest,
  getReservationInfoByPeriodRequest,
  sendEmailTicketsRequest,
  getSingleTicketInfoRequest,
  editTicketRequest,
};
